(function () {

  'use strict';

  angular.module('eclipseApp.login')
    .factory('signinService', ['downgradedUserService', function (downgradedUserService) {
      var deeplinkUrl = '';
      var ssoDeeplinkUrl = '';

      function setDeeplinkUrl(url) {
        deeplinkUrl = url;
      }

      function getDeeplinkUrl() {
        return deeplinkUrl;
      }

      function setSsoDeeplinkUrl(url) {
        ssoDeeplinkUrl = url;
      }

      function getSsoDeeplinkUrl() {
        return ssoDeeplinkUrl;
      }

      function setLoadingIndicator(value) {
        downgradedUserService.setLoadingIndicator(value);
      }

      function getLoadingIndicator() {
        return downgradedUserService.getLoadingIndicator();
      }

      return {
        setDeeplinkUrl: setDeeplinkUrl,
        getDeeplinkUrl: getDeeplinkUrl,
        setSsoDeeplinkUrl: setSsoDeeplinkUrl,
        getSsoDeeplinkUrl: getSsoDeeplinkUrl,
        setLoadingIndicator: setLoadingIndicator,
        getLoadingIndicator: getLoadingIndicator
      };
    }]);

})();
